import { playTurboHostList } from '@/config/host'
import { NODE_ENV } from '@com/config/env'
import { jsonToQuery } from '@com/utils/url'
import { isIvPage } from '@ps/router/config'

export const navigateToPlayturboHomePage = (): void => {
  window.location.href = '/'
}

export const navigateToPtPreview = (query: any): void => {
  // 跳转预览逻辑增加是否互动视频编辑器来源字段
  if (isIvPage()) {
    query.isIvPage = 1
  }
  window.open(
    `${playTurboHostList[NODE_ENV].toString()}/#/pl-viewer?${jsonToQuery(
      query,
    )}`,
    '_blank',
  )
}

/**
 * 跳转到我的作品列表页面
 */
export type ProjectType = 'playsmart' | 'normal'
export function navigateToPlayturboWorks(type: ProjectType): void {
  window.location.href = `/#/my-project/playable?project_type=${type}`
}

/**
 * 下载文件
 * @param fileUrl 下载文件链接
 */
export const downloadFile = (fileUrl: string): void => {
  const a = document.createElement('a')
  a.href = fileUrl
  document.body.appendChild(a)
  a.click()
  document.body.removeChild(a)
}
